/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Équipement complémentaire du bien — libellés et compatibilité avec la nature dans form-rules/property-form.json (champ complements)
 */
export const propertyComplementaryTypeCodeSchema = z.enum(["ELEVATOR", "CELLAR", "ALARM", "INTERCOM", "DIGICODE", "VIDEOPHONE", "GUARDIAN", "DOUBLE_GLAZING", "ROLLER_SHUTTERS", "TERRACE", "BALCONY", "POOL", "OUTBUILDING"]).describe("Équipement complémentaire du bien — libellés et compatibilité avec la nature dans form-rules/property-form.json (champ complements)")